import React from 'react';
import '../index.css';
import './Unauthorized.css';

const Unauthorized = () => {
    return (
        <div className='container-error'>
            <h1>No Autorizado</h1>
            <p>Lo sentimos, no tienes permiso para acceder a esta página.</p>
        </div>
    );
};

export default Unauthorized;
